import SectionCalendars from '@/templates/booking-rules/section-calendars/section-calendars.view';
import SectionLimits from '@/templates/booking-rules/section-limits/section-limits.view';
import SectionPto from '@/templates/booking-rules/section-pto/section-pto.view';
import SectionSchedule from '@/templates/booking-rules/section-schedule/section-schedule.view';
import IResource from '@/types/IResource';
import { Box, Text } from '@chakra-ui/react';
import useEditAvailabilityModalBody from './edit-availability-modal-body-controller';

interface IProps {
	resource: IResource;
}

export default function EditAvailabilityModalBody(props: IProps) {
	const { handleBookingRulesChanged, t } = useEditAvailabilityModalBody(props);

	return (
		<Box>
			<Text fontWeight={500} mb={4}>
				{t('Choose when you want to be available for bookings.')}
			</Text>

			<SectionSchedule bookingRules={props.resource.bookingRules} onChange={handleBookingRulesChanged} />
			<SectionLimits bookingRules={props.resource.bookingRules} onChange={handleBookingRulesChanged} />
			<SectionCalendars bookingRules={props.resource.bookingRules} onChange={handleBookingRulesChanged} />
			<SectionPto bookingRules={props.resource.bookingRules} onChange={handleBookingRulesChanged} />
		</Box>
	);
}
